import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-verify-employee',
  templateUrl: './view-verify-employee.component.html',
  styleUrls: ['./view-verify-employee.component.css']
})
export class ViewVerifyEmployeeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
